import {Caregiver, Patient} from '@drl/shared/models';

export class PatientCaregiver {
  patient: Patient;
  careGiver: Caregiver;
}
